import { type BaseComponent } from '@libs/ui/ds/lib/internals'
import { cva } from 'class-variance-authority'
import type { FC, HTMLAttributes } from 'react'

import { TopNavbarItem } from '../TopNavbarItem/TopNavbarItem'

const topNavbarLogoCVA = cva(['h-4 min-h-4'])

type Props = BaseComponent &
  HTMLAttributes<HTMLImageElement> & {
    imageUrl: string
    alt?: string
    onClick?: () => void
    active?: boolean
  }

export const TopNavbarLogo: FC<Props> = ({
  imageUrl,
  className,
  alt = 'Logo',
  onClick,
  active = false,
  ...otherProps
}) => {
  return (
    <TopNavbarItem onClick={onClick} active={active}>
      <img
        src={imageUrl}
        alt={alt}
        className={topNavbarLogoCVA({ className })}
        {...otherProps}
      />
    </TopNavbarItem>
  )
}
